import React from "react";
import "../../styles/Layout.css";
import "../../styles/Components.css";
import "../../styles/Game.css";

const ComboMode = ({ gameState, gameContext, appSize }) => {
  const {
    leftArmImage,
    rightArmImage,
    punchSequence,
    currentPunchIndex,
    dodgeAnticipation,
    characterX,
    gloveX,
    hitboxDebugInfo,
  } = gameContext;

  const renderPunchCircles = () => {
    if (!punchSequence || punchSequence.length === 0) return null;

    return punchSequence.slice(currentPunchIndex).map((move, relativeIndex) => {
      const absoluteIndex = currentPunchIndex + relativeIndex;
      const isCurrent = relativeIndex === 0;

      let yPosition;
      if (appSize.width < 642) {
        const spacing = appSize.width * 0.1;
        yPosition = relativeIndex * spacing + appSize.width * 0.63;
      } else {
        const spacing = 50;
        yPosition = relativeIndex * spacing + 400;
      }

      if (move.type === "dodge") {
        const imageUrl =
          move.side === "left"
            ? `${process.env.PUBLIC_URL}/assets/img/glove_l.png`
            : `${process.env.PUBLIC_URL}/assets/img/glove_r.png`;

        const gloveClass = `dodge-glove ${move.side} ${
          isCurrent && dodgeAnticipation ? "anticipation" : ""
        } ${isCurrent ? "current" : ""}`;

        const style = {
          bottom: `${yPosition}px`,
        };

        if (isCurrent) {
          // Translate with vw for a viewport-relative movement instead of %
          style["--glove-translate-x"] = `${(gloveX - 0.5) * 80}vw`;
        }

        return (
          <img
            key={`dodge-${absoluteIndex}`}
            src={imageUrl}
            alt={`${move.side} dodge`}
            className={gloveClass}
            style={style}
          />
        );
      }

      // Existing punch circle rendering
      let circleSize;
      if (appSize.width < 642) {
        circleSize = appSize.width * 0.32;
      } else {
        circleSize = 180;
      }

      return (
        <div
          key={`punch-${absoluteIndex}`}
          className={`punch-circle ${move.side} ${isCurrent ? "current" : ""}`}
          style={{
            bottom: `${yPosition}px`,
            width: `${circleSize}px`,
            height: `${circleSize}px`,
          }}
        />
      );
    });
  };

  const renderHitboxes = () => {
    if (!hitboxDebugInfo) return null;

    const { head, glove, isHit } = hitboxDebugInfo;
    const headStyle = {
      display: "none",
      left: `${head.min * 100}%`,
      width: `${(head.max - head.min) * 100}%`,
      backgroundColor: isHit ? "rgba(255, 0, 0, 0.5)" : "rgba(0, 255, 0, 0.5)",
    };
    const gloveStyle = {
      display: "none",
      left: `${glove.min * 100}%`,
      width: `${(glove.max - glove.min) * 50}%`,
      backgroundColor: "rgba(150, 0, 150, 0.5)",
    };

    return (
      <div className="hitbox-container">
        <div className="hitbox head" style={headStyle}></div>
        <div className="hitbox glove" style={gloveStyle}></div>
      </div>
    );
  };

  if (gameState === "idle" || gameState === "ready") {
    return <div>Get Ready...</div>;
  }

  return (
    <div className="combo-mode-layout">
      {renderPunchCircles()}
      {renderHitboxes()}
      <div
        className="character-container"
        style={{
          "--character-translate-x": `${(characterX - 0.5) * 80}vw`,
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/assets/img/character.png`}
          alt="Character"
          className="character-image"
        />
        <img src={leftArmImage} alt="Left Arm" className="arm-image-left" />
        <img src={rightArmImage} alt="Right Arm" className="arm-image-right" />
      </div>
    </div>
  );
};

export default ComboMode;
